import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { DeviceInformationPlugin } from './definitions';
import { CAPACITOR_DEVICE_INFORMATION_PLUGIN } from '../pluginConstants';

const DeviceInformationRaw = registerPlugin<DeviceInformationPlugin>(CAPACITOR_DEVICE_INFORMATION_PLUGIN);
const DeviceInformation = withBridgedStackTrace(DeviceInformationRaw, CAPACITOR_DEVICE_INFORMATION_PLUGIN);

export * from './definitions';
export { DeviceInformation };
